import type { Button } from "../../../../../../../../mads/Button/Button";
import type { GettextInterface } from "../../../../../../../../shared/I18n";
import type { ComponentProps } from "react";

import Sentiment from "../../../../../../../../shared/util/salary/Sentiment";
import { InferenceMethod } from "../../../requirements/TaxonomyEntity";

type ButtonProps = ComponentProps<typeof Button>;

export const getWasInferred = (inferenceMethod?: InferenceMethod) =>
  !!inferenceMethod &&
  [
    InferenceMethod.STRONGLY_INFERRED,
    InferenceMethod.WEAKLY_INFERRED,
    InferenceMethod.EXTRACTED,
  ].includes(inferenceMethod);

export const shouldShowResetButton = ({
  inferenceMethod,
  originalSentiment,
  showSalary,
}: {
  inferenceMethod?: InferenceMethod;
  originalSentiment: Sentiment;
  sentiment: Sentiment;
  showSalary: boolean;
}) => {
  if (showSalary) {
    return false;
  }

  if (originalSentiment === Sentiment.UNKNOWN || getWasInferred(inferenceMethod)) {
    return false;
  } else {
    return true;
  }
};

export const getFooterButtons = ({
  sentiment,
  inferenceMethod,
  originalSentiment,
  loading,
  showSalary,
  gt,
  onModalReset,
  handleSave,
  onClose,
}: {
  inferenceMethod?: InferenceMethod;
  sentiment: Sentiment;
  originalSentiment: Sentiment;
  loading: boolean;
  showSalary?: boolean;
  gt: GettextInterface;
  handleSave: (s: Sentiment, isPrimaryButton?: boolean) => Promise<boolean>;
  onModalReset: () => Promise<boolean>;
  onClose: () => void;
}): any[] | undefined => {
  const result = [];
  const showSaveButton = showSalary;
  if (
    shouldShowResetButton({
      inferenceMethod,
      originalSentiment,
      sentiment,
      showSalary: !!showSalary,
    })
  ) {
    result.push({
      label: gt.gettext("Clear response"),
      props: {
        testID: "modal-reset",
        variant: "text" as ButtonProps["variant"],
        onPress: () => {
          onModalReset().catch(() => {});
        },
        disabled: sentiment === Sentiment.UNKNOWN || loading,
      },
    });
  }
  if (showSaveButton) {
    result.push({
      label: gt.pgettext("Submit modal qualification response", "Save"),
      props: {
        testID: "modal-save",
        variant: "primary" as ButtonProps["variant"],
        size: "lg",
        onPress: async () => {
          const success = await handleSave(sentiment).catch(() => {});
          if (success) {
            onClose();
          }
        },
        disabled: loading,
      },
    });
  }

  return result.length > 0 ? result : undefined;
};
